module.exports = __webpack_public_path__ + "static/img/tup3.f490dd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup3.png
// module id = xbRx
// module chunks = 0